import { GetStateFunction } from 'gf-types';
import { GoFormzServices } from '../../AppSettings';
import { apimCall } from '../../helpers/api';
import {
  OnboardingDispatch,
  OnboardingAction,
  OnboardingCompletionStateRequest,
  OnboardingStepsResponse,
  OnboardingCompletionStateResponse,
  OnboardingPayload
} from './choose-journey-types';

export const ONBOARDING_CHANGE_STEP = 'ONBOARDING_CHANGE_STEP';
export const ONBOARDING_COMPLETE_ITEM = 'ONBOARDING_COMPLETE_ITEM';
export const ONBOARDING_COMPLETED_ITEMS_REQUEST = 'ONBOARDING_COMPLETED_ITEMS_REQUEST';
export const ONBOARDING_COMPLETED_ITEMS_REQUEST_FAILED = 'ONBOARDING_COMPLETED_ITEMS_REQUEST_FAILED';
export const ONBOARDING_COMPLETED_ITEMS_REQUEST_SUCCESS = 'ONBOARDING_COMPLETED_ITEMS_REQUEST_SUCCESS';
export const ONBOARDING_DONT_SHOW_FIELD_ICON = 'ONBOARDING_DONT_SHOW_FIELD_ICON';
export const ONBOARDING_DONT_SHOW_FIELD_ICON_FAILED = 'ONBOARDING_DONT_SHOW_FIELD_ICON_FAILED';
export const ONBOARDING_FIRST_FIELD_DROPPED = 'ONBOARDING_FIRST_FIELD_DROPPED';
export const ONBOARDING_FIRST_FIELD_DROPPED_FAILED = 'ONBOARDING_FIRST_FIELD_DROPPED_FAILED';
export const ONBOARDING_REQUEST = 'ONBOARDING_REQUEST';
export const ONBOARDING_REQUEST_FAILED = 'ONBOARDING_REQUEST_FAILED';
export const ONBOARDING_REQUEST_SUCCESS = 'ONBOARDING_REQUEST_SUCCESS';
export const ONBOARDING_STEPS_REQUEST = 'ONBOARDING_STEPS_REQUEST';
export const ONBOARDING_STEPS_REQUEST_SUCCESS = 'ONBOARDING_STEPS_REQUEST_SUCCESS';
export const ONBOARDING_STEPS_REQUEST_FAILED = 'ONBOARDING_STEPS_REQUEST_FAILED';

export function completeItem(currentStep: number, itemNo: number): OnboardingAction {
  return { type: ONBOARDING_COMPLETE_ITEM, payload: { currentStep, itemNo } };
}

export function changeStep(newStepNo: number): OnboardingAction {
  return { type: ONBOARDING_CHANGE_STEP, payload: { currentStep: newStepNo } };
}

export function getOnboardingSteps() {
  return async function (dispatch: OnboardingDispatch) {
    try {
      dispatch({ type: ONBOARDING_STEPS_REQUEST });

      const { data: stepResponse } = await apimCall<OnboardingStepsResponse>(GoFormzServices.AccountService, '/profile/onboardingsteps');

      dispatch({ type: ONBOARDING_STEPS_REQUEST_SUCCESS, payload: { steps: stepResponse.data } });
    } catch (error) {
      dispatch({ type: ONBOARDING_STEPS_REQUEST_FAILED, payload: { errorMessage: error } });
    }
  };
}

export function updateCompletedItems() {
  return async function (dispatch: OnboardingDispatch, getState: GetStateFunction) {
    try {
      dispatch({ type: ONBOARDING_COMPLETED_ITEMS_REQUEST });

      const state = getState();
      const { completedItems, currentStep } = state.onboarding;

      const completionState: OnboardingCompletionStateRequest = {
        completionState: {
          completedItems,
          currentStep
        }
      };

      await apimCall<number>(GoFormzServices.AccountService, '/profile/onboarding', 'PUT', completionState);

      dispatch({ type: ONBOARDING_COMPLETED_ITEMS_REQUEST_SUCCESS });
    } catch (error) {
      dispatch({ type: ONBOARDING_COMPLETED_ITEMS_REQUEST_FAILED, payload: { errorMessage: error } });
    }
  };
}

export function getOnboardingState() {
  return async function (dispatch: OnboardingDispatch) {
    try {
      dispatch({ type: ONBOARDING_REQUEST });
      // fetch the onboarding states we care about
      const { data } = await apimCall<OnboardingCompletionStateResponse>(GoFormzServices.AccountService, '/profile/onboarding');
      const payload: OnboardingPayload = {
        completedItems: data.completionState.completedItems,
        currentStep: data.completionState.currentStep,
        dontShowOnboardingFieldIcon: data.dontShowOnboardingFieldIcon,
        hasDroppedFirstField: data.hasDroppedFirstField
      };

      dispatch({ type: ONBOARDING_REQUEST_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ONBOARDING_REQUEST_FAILED, payload: { errorMessage: error } });
    }
  };
}

export function updateFirstFieldDropped(dropped = true) {
  return async function (dispatch: OnboardingDispatch, getState: GetStateFunction) {
    try {
      const { onboarding } = getState();
      const { currentStep, completedItems } = onboarding;
      // the put endpoint expects the current completion state which isn't stored in the same
      // format as the backend dto...recreate it
      const data = {
        hasDroppedFirstField: dropped,
        completionState: {
          currentStep,
          completedItems
        }
      };

      dispatch({ type: ONBOARDING_FIRST_FIELD_DROPPED, payload: { hasDroppedFirstField: dropped } });
      await apimCall<void>(GoFormzServices.AccountService, '/profile/onboarding', 'PUT', data);
    } catch (error) {
      dispatch({ type: ONBOARDING_FIRST_FIELD_DROPPED_FAILED, payload: { errorMessage: error, hasDroppedFirstField: !dropped } });
    }
  };
}

export function updatedDontShowOnboardingFieldIcon(show = false) {
  return async function (dispatch: OnboardingDispatch, getState: GetStateFunction) {
    try {
      const rootState = getState();
      const data = { ...rootState.onboarding, dontShowOnboardingFieldIcon: show };

      dispatch({ type: ONBOARDING_DONT_SHOW_FIELD_ICON, payload: { dontShowOnboardingFieldIcon: show } });
      await apimCall<void>(GoFormzServices.AccountService, '/profile/onboarding', 'PUT', data);
    } catch (error) {
      dispatch({ type: ONBOARDING_DONT_SHOW_FIELD_ICON_FAILED, payload: { errorMessage: error, dontShowOnboardingFieldIcon: !show } });
    }
  };
}
